"use client";

import { Button } from "@workspace/ui/components/button";
import { cn } from "@workspace/ui/lib/utils";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { FINAL_CTA, LEAD_FORM_ANCHOR } from "./content";
import { useLeadFormDialog } from "./lead-form-dialog";
import { LeadFormLink } from "./lead-form-link";

export const HERO_SENTINEL_ID = "hero-end";

/**
 * On phones the final CTA sits several screens below the fold, so the page
 * keeps a reachable button once the hero scrolls away and hides it again when
 * that section — or the lead dialog — is already on screen.
 */
export function StickyMobileCta() {
  const { isOpen } = useLeadFormDialog();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const heroEnd = document.getElementById(HERO_SENTINEL_ID);
    const leadForm = document.getElementById(LEAD_FORM_ANCHOR.slice(1));
    if (!heroEnd || !leadForm) return;

    let scrolledPastHero = false;
    let leadFormVisible = false;

    function update() {
      setVisible(scrolledPastHero && !leadFormVisible);
    }

    const heroObserver = new IntersectionObserver(([entry]) => {
      scrolledPastHero = Boolean(
        entry && !entry.isIntersecting && entry.boundingClientRect.top < 0,
      );
      update();
    });

    const leadFormObserver = new IntersectionObserver(([entry]) => {
      leadFormVisible = Boolean(entry?.isIntersecting);
      update();
    });

    heroObserver.observe(heroEnd);
    leadFormObserver.observe(leadForm);

    return () => {
      heroObserver.disconnect();
      leadFormObserver.disconnect();
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-t border-[#262321] bg-[#262321]/95 p-3 backdrop-blur transition-transform duration-200 md:hidden",
        visible && !isOpen ? "translate-y-0" : "translate-y-full",
      )}
      aria-hidden={!visible || isOpen}
    >
      <Button
        asChild
        size="lg"
        className="w-full border border-[#262321] bg-[#E5E244] py-5 text-base font-bold text-[#262321] hover:bg-[#E5E244]"
      >
        <LeadFormLink
          location="sticky_mobile"
          tabIndex={visible && !isOpen ? 0 : -1}
        >
          {FINAL_CTA.stickyCta}
          <ArrowRight />
        </LeadFormLink>
      </Button>
    </div>
  );
}
